import { render } from "./MoraleducationEvaluation.vue?vue&type=template&id=40b007a2&scoped=true"
import script from "./MoraleducationEvaluation.vue?vue&type=script&lang=js"
export * from "./MoraleducationEvaluation.vue?vue&type=script&lang=js"

import "./MoraleducationEvaluation.vue?vue&type=style&index=0&id=40b007a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40b007a2"]])

export default __exports__